<template>
  <v-card flat>
    <v-card-title>
      Telemetry data for marketing
      <v-btn-toggle
        v-model="toggle"
        class="ml-5"
        color="primary"
        mandatory
        rounded
        dense
        @change="$router.push({ name: 'telemetry-marketing', params: { buildTag: toggle } })"
      >
        <v-btn
          value="PCMaster"
        >
          PCMaster
        </v-btn>
        <v-btn
          value="NEWdemo"
        >
          NEWdemo
        </v-btn>
        <v-btn
          value="demo"
        >
          demo
        </v-btn>
        <v-btn
          value="trunk"
        >
          trunk
        </v-btn>
        <v-btn
          value="test"
        >
          test
        </v-btn>
      </v-btn-toggle>
    </v-card-title>
    <v-card-text>
      <div class="grid">
        <v-lazy
          :options="{
            threshold: .5
          }"
          transition="fade-transition"
        >
          <div>
            <global-info />
            <global-pirates-info class="mt-4"/>
          </div>
        </v-lazy>
        <v-lazy
          :options="{
            threshold: .5
          }"
          transition="fade-transition"
        >
          <global-death />
        </v-lazy>
        <v-lazy
          :options="{
            threshold: .5
          }"
          transition="fade-transition"
        >
          <global-enemy-death />
        </v-lazy>
        <v-lazy
          :options="{
            threshold: .5
          }"
          transition="fade-transition"
        >
          <global-movement />
        </v-lazy>
        <v-lazy
          :options="{
            threshold: .5
          }"
          transition="fade-transition"
        >
          <GlobalTimeInUI />
        </v-lazy>
        <v-lazy
          :options="{
            threshold: .5
          }"
          transition="fade-transition"
        >
          <global-boss-fights />
        </v-lazy>
        <v-lazy
          :options="{
            threshold: .5
          }"
          transition="fade-transition"
        >
          <global-shots />
        </v-lazy>
        <v-lazy
          :options="{
            threshold: .5
          }"
          transition="fade-transition"
        >
          <global-reloads />
        </v-lazy>
        <v-lazy
          :options="{
            threshold: .5
          }"
          transition="fade-transition"
        >
          <global-equiped-weapon />
        </v-lazy>
        <v-lazy
          :options="{
            threshold: .5
          }"
          transition="fade-transition"
        >
          <global-craft />
        </v-lazy>
        <v-lazy
          :options="{
            threshold: .5
          }"
          transition="fade-transition"
        >
          <global-drop />
        </v-lazy>
        <v-lazy
          :options="{
            threshold: .5
          }"
          transition="fade-transition"
        >
          <global-pick-up />
        </v-lazy>
        <v-lazy
          :options="{
            threshold: .5
          }"
          transition="fade-transition"
        >
          <global-healing />
        </v-lazy>
        <v-lazy
          :options="{
            threshold: .5
          }"
          transition="fade-transition"
        >
          <skipped-cutscenes-data-service />
        </v-lazy>
        <v-lazy
          :options="{
            threshold: .5
          }"
          transition="fade-transition"
        >
          <links-clicked-by-user />
        </v-lazy>
        <v-lazy
          :options="{
            threshold: .5
          }"
          transition="fade-transition"
        >
          <locale />
        </v-lazy>
        <v-lazy
          :options="{
            threshold: .5
          }"
          transition="fade-transition"
        >
          <store />
        </v-lazy>
      </div>
      <v-lazy
        :options="{
          threshold: .5
        }"
        transition="fade-transition"
      >
        <div class="mt-5">
          <soft-drop-section />
        </div>
      </v-lazy>
      <v-lazy
        :options="{
          threshold: .5
        }"
        transition="fade-transition"
      >
        <div class="mt-5">
          <tension-beats-column-chart />
        </div>
      </v-lazy>
      <v-lazy
        :options="{
          threshold: .5
        }"
        transition="fade-transition"
      >
        <div class="mt-5">
          <playtime-by-tension-beats-column-chart />
        </div>
      </v-lazy>
      <v-lazy
        :options="{
          threshold: .5
        }"
        transition="fade-transition"
      >
        <div class="mt-5">
          <unique-users-area-chart />
        </div>
      </v-lazy>
      <v-lazy
        :options="{
          threshold: .5
        }"
        transition="fade-transition"
      >
        <div class="mt-5">
          <completion-rate-area-chart />
        </div>
      </v-lazy>
      <v-lazy
        :options="{
          threshold: .5
        }"
        transition="fade-transition"
      >
        <div class="mt-5">
          <playtime-by-users-area-chart />
        </div>
      </v-lazy>
      <v-lazy
        :options="{
          threshold: .5
        }"
        transition="fade-transition"
      >
        <div class="mt-5">
          <enemy-death-chart />
        </div>
      </v-lazy>
      <v-lazy
        :options="{
          threshold: .5
        }"
        transition="fade-transition"
      >
        <div class="mt-5">
          <invastogation-space-bar-chart />
        </div>
      </v-lazy>
      <v-lazy
        :options="{
          threshold: .5
        }"
        transition="fade-transition"
      >
        <div class="mt-5">
          <PCConfigurationTable />
        </div>
      </v-lazy>
      <v-lazy
        :options="{
          threshold: .5
        }"
        transition="fade-transition"
      >
        <div class="mt-5">
          <FPSChart />
        </div>
      </v-lazy>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  components: {
    GlobalInfo: () => import('../../components/marketing-telemetry-components/globalInfo.vue'),
    GlobalPiratesInfo: () => import('../../components/marketing-telemetry-components/globalPiratesInfo.vue'),
    GlobalMovement: () => import('../../components/marketing-telemetry-components/global-movement'),
    GlobalShots: () => import('../../components/marketing-telemetry-components/global-shots'),
    GlobalReloads: () => import('../../components/marketing-telemetry-components/global-reloads'),
    GlobalEquipedWeapon: () => import('../../components/marketing-telemetry-components/global-equiped-weapon'),
    GlobalCraft: () => import('../../components/marketing-telemetry-components/global-craft'),
    GlobalDrop: () => import('../../components/marketing-telemetry-components/global-drop'),
    GlobalPickUp: () => import('../../components/marketing-telemetry-components/global-pick-up'),
    GlobalDeath: () => import('../../components/marketing-telemetry-components/global-death'),
    GlobalHealing: () => import('../../components/marketing-telemetry-components/global-healing'),
    GlobalTimeInUI: () => import('../../components/marketing-telemetry-components/global-time-in-ui'),
    InvastogationSpaceBarChart: () => import('../../components/marketing-telemetry-components/invastogationSpaceBarChart.vue'),
    SkippedCutscenesDataService: () => import('../../components/marketing-telemetry-components/skipped-cutscenes-data'),
    GlobalBossFights: () => import('../../components/marketing-telemetry-components/global-boss-fights'),
    GlobalEnemyDeath: () => import('../../components/marketing-telemetry-components/global-enemy-death'),
    EnemyDeathChart: () => import('../../components/marketing-telemetry-components/enemyDeathChart.vue'),
    PCConfigurationTable: () => import('../../components/marketing-telemetry-components/pcConfigurationTable.vue'),
    LinksClickedByUser: () => import('../../components/marketing-telemetry-components/links-clicked-by-user'),
    TensionBeatsColumnChart: () => import('../../components/marketing-telemetry-components/tensionBeatsColumnChart.vue'),
    UniqueUsersAreaChart: () => import('../../components/marketing-telemetry-components/uniqueUsersAreaChart.vue'),
    CompletionRateAreaChart: () => import('../../components/marketing-telemetry-components/completionRateAreaChart.vue'),
    PlaytimeByUsersAreaChart: () => import('../../components/marketing-telemetry-components/playtimeByUsersAreaChart.vue'),
    Locale: () => import('../../components/marketing-telemetry-components/locale'),
    Store: () => import('../../components/marketing-telemetry-components/store'),
    FPSChart: () => import('../../components/marketing-telemetry-components/fpsChart.vue'),
    SoftDropSection: () => import('../../components/marketing-telemetry-components/softDropSection.vue'),
    PlaytimeByTensionBeatsColumnChart: () => import('../../components/marketing-telemetry-components/tensionBeatsPlaytimeColumnChart.vue')
  },
  data() {
    return {
      toggle: this.$route.params.buildTag || 'demo'
    }
  }
}
</script>

<style lang="css" scoped>
  .grid {
    columns: 3;
    column-gap: 16px;
  }

  .grid > * {
    break-inside: avoid;
    margin-bottom: 16px;
  }
</style>
